export default __webpack_public_path__ + "static/heartfulness-green-donation-banner-2e9d2b829f77240a48b9b4c4d6bb78a0.jpg";